import TextareaAutosize from '@mui/material/TextareaAutosize';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { v4 as uuidv4 } from 'uuid';

import { FormGroup, TextField } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import {
  OPEN_ENDED_INPUT,
  OPEN_ENDED,
  SINGLE_SELECT,
  MULTI_SELECT,
  MORE_SELECTIONS,
  NONE,
} from '.';

import './GeneralSurveyModalContent.css';

export const getGeneralSurveyQuestionField = ({
  questionsObj,
  question,
  surveyQuestionType,
  handleChange,
  userId,
}) => {
  const fieldObj = {
    [OPEN_ENDED_INPUT]: ({ selectedValue }) => (
      <TextField
        sx={{
          border: '1px solid black',
          fontFamily: 'sans-serif',
          marginLeft: '25px',
          width: '93%',
        }}
        value={selectedValue}
        onChange={(e) => {
          handleChange({
            value: e.target.value,
            question,
            surveyQuestionType,
            fieldType: OPEN_ENDED_INPUT,
            userId,
          });
        }}
        autoComplete="off"
        variant="outlined"
      />
    ),
    [OPEN_ENDED]: ({ selectedValue }) => (
      <TextareaAutosize
        value={selectedValue}
        onChange={(e) => {
          handleChange({
            value: e.target.value,
            question,
            surveyQuestionType,
            fieldType: OPEN_ENDED,
          });
        }}
        minRows={3}
        id="survey-open-ended-textarea"
      />
    ),
    [SINGLE_SELECT]: ({ selectedValue }) => (
      <FormControl>
        <RadioGroup
          name="radio-buttons-group"
          sx={{ marginLeft: '25px' }}
          value={selectedValue}
          onChange={(e) => {
            handleChange({
              value: e.target.value,
              question,
              surveyQuestionType,
              fieldType: SINGLE_SELECT,
            });
          }}
          row
        >
          {Object.values(questionsObj?.[question]?.Selections).map(({ text, value }) => {
            return (
              <FormControlLabel
                value={value}
                control={<Radio style={{ color: 'black', padding: '5px' }} size="small" />}
                sx={{ width: { xs: '140px', md: '145px' }, mt: 0.4 }}
                label={text}
                key={uuidv4()}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    ),
    [MULTI_SELECT]: ({ selectedValue }) => (
      <FormGroup row sx={{ marginLeft: '20px' }}>
        {Object.values(questionsObj?.[question]?.Selections).map(({ text, value }) => {
          return (
            <FormControlLabel
              onChange={(e) => {
                handleChange({
                  value: e.target.value,
                  question,
                  surveyQuestionType,
                  fieldType: MULTI_SELECT,
                });
              }}
              control={
                <Checkbox
                  value={value}
                  checked={selectedValue?.hasOwnProperty(value)}
                  size="small"
                  style={{ color: 'black' }}
                  sx={{ padding: '5px' }}
                />
              }
              label={text}
              sx={{ marginLeft: '-6px', width: { xs: '135px', md: '140px' }, mt: 0.4 }}
              key={uuidv4()}
            />
          );
        })}
      </FormGroup>
    ),
    [NONE]: () => {
      return <></>;
    },
    [MORE_SELECTIONS]: () => {
      return (
        <div className="more-selections-wrapper">
          {' '}
          {Object.values(questionsObj?.[question]?.Selections).map(({ moreInfo, VALUE, text }) => {
            return (
              <FormControl>
                <h4 className="more-selections-section-header-wrapper">{text}</h4>
                <RadioGroup
                  value={VALUE}
                  name="radio-buttons-group"
                  sx={{ marginLeft: '0px' }}
                  onChange={(e) =>
                    handleChange({
                      value: e.target.value,
                      question,
                      surveyQuestionType,
                      fieldType: MORE_SELECTIONS,
                      header: text,
                    })
                  }
                  row
                >
                  {Object.values(moreInfo?.Selections).map(({ text, value }) => {
                    return (
                      <FormControlLabel
                        value={value}
                        sx={{ width: { xs: '60px', md: '145px' }, mt: 0.4 }}
                        control={
                          <Radio
                            style={{ color: 'black', padding: '5px', width: '38px' }}
                            size="small"
                          />
                        }
                        label={text}
                      />
                    );
                  })}
                </RadioGroup>
              </FormControl>
            );
          })}
        </div>
      );
    },
  };

  let selectedValue = questionsObj?.[question]?.VALUE;
  let currentType = questionsObj[question].type;
  if (currentType === MORE_SELECTIONS) {
    selectedValue = null;
  }

  return fieldObj[currentType]?.({ selectedValue });
};

export const getSurveyQuestionsCompletedHeader = (surveyType = 'this step') => {
  return `Survey Questions for ${surveyType} has been submitted!`;
};
